<template>
    <fragment>
        <th>
            <panorama-header-item title="Détails" />
        </th>
        <th class="add-width">
            <panorama-header-item title="Description" />
        </th>
        <th>
            <panorama-header-item title="CSP" />
        </th>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import PanoramaHeaderItem from "../../PanoramaHeaderItem.vue";

export default {
    components: { Fragment, PanoramaHeaderItem },
    props: ["subject"],
};
</script>

<style scoped lang="sass">
.add-width
    width: 450px
</style>
